import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Location(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Location", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M36 16.3333C36 22.5667 24.5 39 24.5 39S13 22.5667 13 16.3333C13 10.1 18.175 5 24.5 5S36 10.1 36 16.3333Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24.5 23c3.5899 0 6.5-2.9101 6.5-6.5S28.0899 10 24.5 10 18 12.9101 18 16.5s2.9101 6.5 6.5 6.5Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M23.9048 19.3333c-.5429 0-.9048-.3619-.9048-.9047v-4.5238c0-.5429.3619-.9048.9048-.9048.5428 0 .9047.3619.9047.9048v4.5238c0 .5428-.3619.9047-.9047.9047Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27.5238 19.333h-3.619c-.5429 0-.9048-.3619-.9048-.9048s.3619-.9048.9048-.9048h3.619c.5429 0 .9048.3619.9048.9048s-.3619.9048-.9048.9048ZM24 44.4511c-7.5 0-15-1.9687-15-5.625 0-2.25 3-4.125 8.25-5.0625.4687-.0937 1.0312.2813 1.125.75.0938.4688-.2812 1.0313-.75 1.125-4.9687.8438-6.75 2.3438-6.75 3.1875 0 1.5 5.1562 3.75 13.125 3.75s13.125-2.25 13.125-3.75c0-.8437-1.7812-2.3437-6.75-3.1875-.4688-.0937-.8438-.5625-.75-1.125.0938-.4687.5625-.8437 1.125-.75C36 34.7011 39 36.5761 39 38.8261c0 3.6563-7.5 5.625-15 5.625Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Location.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Location"
};
validateTidalLicense();
export {
  Location
};
//# sourceMappingURL=Location.js.map
